import * as React from "react";
import { ArrowLeft } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { ProductGallery } from "../../components/products/ProductGallery";
import { ProductInfo } from "../../components/products/ProductInfo";
import { ProductAnalytics } from "../../components/products/ProductAnalytics";
import { useGetProductDetailsQuery } from "../../services/product";
import LoadingState from "../../components/states/LoadingState";
import ErrorState from "../../components/states/ErrorState";

function ProductDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: product,
    isLoading,
    error,
    isError,
  } = useGetProductDetailsQuery({
    page: "Product_Details",
    glid: id,
  });

  if (isError) {
    return <ErrorState error={error?.message || "An error occurred"} />;
  }

  if (isLoading || !product) {
    return <LoadingState />;
  }

  // Comments about the product array structure
  // [0] - "page_header" widget
  // [1] - variants "dgv" widget (dgv = proper dgv, "property_grid" = single row dgv for key-value format)
  // [2] - "carousel" widget
  // [3] - "property_grid" widget (single product details)
  // [4] - "chart" widget
  // [5] - campaigns "dgv"

  return (
    <div className=" mx-auto px-4 py-8">
      <button
        onClick={() => navigate("/Product_All")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8"
      >
        <ArrowLeft className="h-5 w-5" />
        <span>Back to Products</span>
      </button>

      <div
        style={{
          backgroundColor: product[0].Color,
        }}
        className="p-2 mb-2"
      >
        <h1 className="text-4xl font-bold text-gray-800 mb-2">
          {product[0].title}
        </h1>
        <h2 className="text-2xl font-medium text-gray-800/75 mb-8">
          {product[0]["sub-title"]}
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <ProductGallery images={product[2].images} />
        <div className="space-y-6">
          <ProductInfo product={product[3]} />
        </div>
      </div>

      <div>
        <ProductAnalytics
          variantTable={product[1]}
          campaignsTable={product[5]}
          variantSalesChartData={product[4]?.data}
        />
      </div>
    </div>
  );
}

export default ProductDetailsPage;
